import { useServiceHealth } from '@/services/status';
import styles from './ServiceStatusList.module.css';

const statusTone = (status?: string) => {
  if (!status) {
    return 'unknown';
  }
  if (status.toLowerCase().includes('ok') || status.toLowerCase().includes('healthy')) {
    return 'healthy';
  }
  if (
    status.toLowerCase().includes('degraded') ||
    status.toLowerCase().includes('warn')
  ) {
    return 'degraded';
  }
  return 'down';
};

export const ServiceStatusList = () => {
  const services = useServiceHealth();

  return (
    <div className={styles.list}>
      {services.map(({ definition, query }) => {
        const tone = statusTone(query.data?.status);
        return (
          <div key={definition.id} className={`${styles.item} ${styles[tone]}`}>
            <div className={styles.header}>
              <span className={styles.label}>{definition.label}</span>
              <span className={styles.status}>{query.data?.status ?? 'Unknown'}</span>
            </div>
            <div className={styles.body}>
              {query.isLoading && <p className={styles.message}>Checking health…</p>}
              {query.isError && (
                <p className={styles.message}>
                  {(query.error as Error).message || 'Unable to reach service'}
                </p>
              )}
              {query.isSuccess && !query.isLoading && !query.isError && (
                <>
                  {query.data?.services && (
                    <ul className={styles.meta}>
                      {Object.entries(query.data.services).map(([key, value]) => (
                        <li key={key}>
                          <span>{key}</span>
                          <span>{String(value)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {query.data?.error && (
                    <p className={styles.message}>{query.data.error}</p>
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
